import { render } from "./WebRadioForm.vue?vue&type=template&id=4ecb026a"
import script from "./WebRadioForm.vue?vue&type=script&lang=js"
export * from "./WebRadioForm.vue?vue&type=script&lang=js"

import "./WebRadioForm.vue?vue&type=style&index=0&id=4ecb026a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__